// Firebase App (the core Firebase SDK) is always required and must be listed first
import * as firebase from "firebase";
import config from "../config";

var firebaseConfig = config().firebaseApiKey;

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export default firebase;
